// imports section Start
import React, { useState, useContext } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { ThemeProvider, CssBaseline, Box, useMediaQuery } from "@mui/material";
import { lightTheme, darkTheme } from "../../assets/styles/Theme";
import { ThemeContext } from "../../utils/common/ThemeContext";

// Import all your components
import Cashier from "../../features/cashier/Cashier";
import Kitchen from "../../features/kitchen/Kitchen";
import Guest from "../../features/guest/Guest";
import PlacedOrder from "../../features/cashier/PlacedOrder";
import AddItems from "../../features/settings/AddItems";
import OtherChanges from "../../features/settings/OtherChanges";
import Category from "../../features/settings/Category";
import ReceiptDetails from "../../features/settings/ReceiptDetails";
import MapPrinters from "../../features/settings/MapPrinters";
import Tables from "../../features/settings/Tables";
import OrderTracking from "../../features/settings/OrderTracking";
import Waiters from "../../features/settings/Waiters";
import AddOns from "../../features/settings/AddOns";
import ViewAddons from "../../features/settings/ViewAddons";
import ViewCatergory from "../../features/settings/ViewCatergory";
import ViewMapPrinter from "../../features/settings/ViewMapPrinter";
import ViewOrderTracking from "../../features/settings/ViewOrderTracking";
import ViewOtherChanges from "../../features/settings/ViewOtherChanges";
import ViewReceiptDetails from "../../features/settings/ViewReceiptDetails";
import ViewTables from "../../features/settings/ViewTables";
import ViewWaiters from "../../features/settings/ViewWaiters";
import SetupMenumeal from "../../features/promotions/SetupMenumeal";
import SetupPromotion from "../../features/promotions/SetupPromotion";
import ViewMenumeal from "../../features/promotions/ViewMenumeal";
import ViewPromotion from "../../features/promotions/ViewPromotion";
import MyProfile from "../../features/employee/MyProfile";
import ViewMyProfile from "../../features/employee/ViewMyProfile";
import ViewMapUser from "../../features/employee/ViewMapUser";
import MapUser from "../../features/employee/MapUser";
import UserGroups from "../../features/employee/UserGroups";
import ViewUserGroups from "../../features/employee/ViewUserGroups";
import Memberships from "../../features/Customer/Memberships";
import ViewMemberships from "../../features/Customer/ViewMemberships";
import GiftCertificate from "../../features/Customer/GiftCertificate";
import ViewGiftCertificate from "../../features/Customer/ViewGiftCertificate";
import Suppiler from "../../features/Customer/Suppiler";
import Customer from "../../features/Customer/Customer";
import NewSuppiler from "../../features/Customer/NewSuppiler";
import NewCustomer from "../../features/Customer/NewCustomer";
import ViewAddItem from "../../features/settings/ViewAddItem";
import BillFormat from "../../features/settings/BillFormat";
import GroupAccess from "../../features/employee/GroupAccess";
import Home from "../../features/dashboard/Home";

import ChangePassword from "../../features/employee/ChangePassword";
import HideSidebar from "../../utils/common/HideSidebar";
import Sidebar from "./sidebar";
import Barcode from "../../features/settings/Barcode";
import ManageOrder from "../../features/Order/ManageOrder";
import Ordercancel from "../../features/Order/Ordercancel";
import DayEnd from "../../features/process/DayEnd";
import Officer from "../../features/Officer/Officer";
import EditItem from "../../features/settings/EditItem";
import GuestBottomNavigation from "../guest/GuestBottomNavigation";
import GuestHeader from "../guest/GuestHeader";
import GuestCheckout from "../../features/guest/GuestCheckout";
import Login from "../../features/main/Login";
import AddGiftVoucher from "../../features/Customer/AddGiftVoucher";
import ViewGiftVoucher from "../../features/Customer/ViewGiftVoucher";
import StockAside from "../../features/stock/StockAside";
import StockItemDet from "../../features/stock/StockItemDet";
import CashReceipt from "../../features/bill/CashReceipt";
import CashBalance from "../../features/cashier/CashBalance";
import SelectReports from "../../features/reports/SelectReports";
import MapReports from "../../features/employee/MapReports";
import ReportView from "../../features/reports/ReportView";
import OrderSuccess from "../../features/sales/OrderSuccess";
import ViewBarcode from "../../features/settings/ViewBarcode";
import CashReceiptA4 from "../../features/bill/CashReceiptA4";
import Cheff from "../../features/cheff/Cheff";
import CheffPlacedOrders from "../../features/cheff/CheffPlacedOrders";
import OrderList from "../../features/Order/OrderList";
import OrderReturn from "../../features/Order/OrderReturn";
import ViewSetupMenucategory from "../../features/promotions/ViewSetupMenucategory";
import SetupMenucategory from "../../features/promotions/SetupMenucategory";
import Schedules from "../schedule/Schedules";
import ViewSchedule from "../schedule/ViewSchedule";
import PrintKOT from "../../features/bill/PrintKOT";
import ViewUberorders from "../../features/uber/ViewUberorders";
import SetupUberMetadata from "../../features/uber/SetupUberMetadata";
import SetupPickmeMetadata from "../../features/pickme/SetupPickmeMetadata";
import ViewPickmeOrders from "../../features/pickme/ViewPickmeOrders";
import ModuleTransfer from "../../features/main/ModuleTransfer";
import ViewMeasuringUnit from "../../features/settings/ViewMeasuringUnit";
import Measuringunit from "../../features/settings/MeasuringUnit";
import RecipeItems from "../../features/recipe/RecipeItems";
import AddRecipe from "../../features/recipe/AddRecipe";
import ViewCategory from "../../features/category/ViewCategory";
import ViewSubcategory from "../../features/category/ViewSubcategory";
import AddCategory from "../../features/category/AddCategory";
import AddSubcategory from "../../features/category/AddSubcategory";
import ViewProduct from "../../features/category/ViewProduct";
import AddProduct from "../../features/category/AddProduct";
// imports section End

const PageRouting = () => {
  // Hooks start

  const { mode, toggleTheme } = useContext(ThemeContext);
  // const [mode, setMode] = React.useState("light");

  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  // Hooks end

  // Handlers start
  const theme = mode === "light" ? lightTheme : darkTheme;
  // const toggleTheme = () => {
  //   setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
  // };

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const hideSidebar = HideSidebar();

  const isGuestPage = location.pathname.startsWith("/Guest");
  const isGuestCheckoutPage = location.pathname.startsWith("/GuestCheckout");
  // Handlers end

  // const accessRights = useSelector((state) => state.accessRights);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {!hideSidebar && (
        <Sidebar
          mode={mode}
          toggleTheme={toggleTheme}
          isMobile={isMobile}
          isSidebarOpen={isSidebarOpen}
          setSidebarOpen={setSidebarOpen}
        />
      )}
      {isGuestPage || isGuestCheckoutPage ? (
        <GuestHeader toggleTheme={toggleTheme} mode={mode} />
      ) : null}

      <Box
        sx={{
          paddingBottom: isGuestPage || isGuestCheckoutPage ? 7 : 0,
          flexGrow: 1,
          width: "100%",
        }}
      >
        <Routes>
          <Route path="/" element={<Navigate to="/Login" />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/Home" element={<Home />} />
          <Route path="/Cashier" element={<Cashier />} />
          <Route path="/Kitchen" element={<Kitchen />} />
          <Route path="/PlacedOrder" element={<PlacedOrder />} />
          <Route path="/AddItem" element={<AddItems />} />
          <Route path="/ViewaddItem" element={<ViewAddItem />} />
          <Route path="/otherchange" element={<OtherChanges />} />
          <Route path="/votherchange" element={<ViewOtherChanges />} />
          <Route path="/category" element={<Category />} />
          <Route path="/vcategory" element={<ViewCatergory />} />
          <Route path="/reciptdetail" element={<ReceiptDetails />} />
          <Route path="/vreciptdetail" element={<ViewReceiptDetails />} />
          <Route path="/mapprinters" element={<MapPrinters />} />
          <Route path="/vmapprinter" element={<ViewMapPrinter />} />
          <Route path="/addons" element={<AddOns />} />
          <Route path="/vaddons" element={<ViewAddons />} />
          <Route path="/tables" element={<Tables />} />
          <Route path="/vtables" element={<ViewTables />} />
          <Route path="/ordertracking" element={<OrderTracking />} />
          <Route path="/vordertracking" element={<ViewOrderTracking />} />
          <Route path="/billformat" element={<BillFormat />} />
          <Route path="/waiters" element={<Waiters />} />
          <Route path="/vwaiters" element={<ViewWaiters />} />
          <Route path="/setupMenumeal" element={<SetupMenumeal />} />
          <Route path="/vsetupMenumeal" element={<ViewMenumeal />} />
          <Route path="/setupPromotion" element={<SetupPromotion />} />
          <Route path="/vsetupPromotion" element={<ViewPromotion />} />
          <Route path="/vmapuser" element={<ViewMapUser />} />
          <Route path="/mapuser" element={<MapUser />} />
          <Route path="/changepasswrd" element={<ChangePassword />} />
          <Route path="/usergroup" element={<UserGroups />} />
          <Route path="/vusergroup" element={<ViewUserGroups />} />
          <Route path="/groupaccess" element={<GroupAccess />} />
          <Route path="/myprofile" element={<MyProfile />} />
          <Route path="/membership" element={<Memberships />} />
          <Route path="/vmembership" element={<ViewMemberships />} />
          <Route path="/Giftcertificate" element={<GiftCertificate />} />
          <Route path="/GiftVoucher" element={<AddGiftVoucher />} />
          <Route path="/vGiftVoucher" element={<ViewGiftVoucher />} />
          <Route path="/vGiftcertificate" element={<ViewGiftCertificate />} />
          <Route path="/supplier" element={<Suppiler />} />
          <Route path="/customer" element={<Customer />} />
          <Route path="/vsupplier" element={<NewSuppiler />} />
          <Route path="/vcustomer" element={<NewCustomer />} />
          <Route path="/stock" element={<StockAside />} />
          <Route path="/stockitemdet" element={<StockItemDet />} />
          <Route path="/barcode" element={<ViewBarcode />} />
          <Route path="/manageorder" element={<ManageOrder />} />
          <Route path="/manageorder" element={<ManageOrder />} />
          <Route path="/orderlist" element={<OrderList />} />
          <Route path="/dayend" element={<DayEnd />} />
          <Route path="/officer" element={<Officer />} />
          <Route path="/EditItem" element={<EditItem />} />
          <Route path="/ordercancel" element={<Ordercancel />} />
          <Route path="/orderreturn" element={<OrderReturn />} />
          <Route path="/OrderSuccess" element={<OrderSuccess />} />
          <Route path="/CashReceipt" element={<CashReceipt />} />
          <Route path="/CashBalance" element={<CashBalance />} />
          <Route path="/Reports" element={<SelectReports />} />
          <Route path="/MapReports" element={<MapReports />} />
          <Route path="/ReportView" element={<ReportView />} />
          <Route path="/Cheff" element={<Cheff />} />
           <Route path="/PrintKOT" element={<PrintKOT />} />
           <Route path="/CashReceiptA4" element={<CashReceiptA4 />} />
           <Route path="/vPromotionMenu" element={<ViewSetupMenucategory />} />
           <Route path="/PromotionMenu" element={<SetupMenucategory />} />
          <Route path="/VSchedule" element={<ViewSchedule />} />
           <Route path="/Schedules" element={<Schedules />} />
          <Route path="/CheffPlacedOrders" element={<CheffPlacedOrders />} />
          <Route path="/ModuleTransfer" element={<ModuleTransfer />} />
          {/* Guest Page */}
          <Route path="/Guest" element={<Guest />} />
          <Route path="/GuestCheckout" element={<GuestCheckout />} />
          <Route path="/ViewUberorders" element={<ViewUberorders />} />
          <Route path="/SetupUberMetadata" element={<SetupUberMetadata />} />
          <Route path="/ViewPickmeOrders" element={<ViewPickmeOrders />} />
          <Route path="/Viewunits" element={<ViewMeasuringUnit />} />
          <Route path="/Measuringunit" element={<Measuringunit/>} />
             <Route path="/RecipeItems" element={<RecipeItems />} />
          <Route path="/maprecipe" element={<AddRecipe />} />
            <Route path="/vreciptdetail" element={<ViewReceiptDetails />} />
          <Route
            path="/SetupPickmeMetadata"
            element={<SetupPickmeMetadata />}
          />
           <Route path="/Vinvcategory" element={<ViewCategory />} />
          <Route path="/invcategory" element={<AddCategory />} />
          <Route path="/Vinvsubcategory" element={<ViewSubcategory />} />
          <Route path="/invsubcategory" element={<AddSubcategory />} />
             <Route path="/ViewProduct" element={<ViewProduct />} />
          <Route path="/AddProduct" element={<AddProduct />} />
        </Routes>
      </Box>
      {(isGuestPage || isGuestCheckoutPage) && <GuestBottomNavigation />}
    </ThemeProvider>
  );
};

export default PageRouting;
